<template>
  <div
      v-if="isLoaded"
      class="guide-line"
      :class="[direction, $store.state.scrollY > 30 ? '' : 'on']"
  >
      <div
          class="slide"
          v-for="(item, index) in localData"
          :class="{'active': item.active}"
          :key="index"
          @click="jump(item)"
      >
        <div class="pin" v-if="direction === 'left'">
          <img src="@/assets/images/icon/pinCover.svg" alt="">
        </div>
        <div class="title">{{ item.label || item.name }}</div>
        <div class="pin" v-if="direction === 'right'">
          <img src="@/assets/images/icon/pinCover.svg" alt="">
        </div>
      </div>
  </div>
</template>

<script>
import {EventBus} from '../../EventBus'

export default {
  name: 'GuideLine',
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    direction: {
      type: String,
      default: 'left'
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        this.localData = val.slice().map((x) => Object.assign(x, {active: false}))
      }
    },
    '$store.state.scrollY': {
      handler () {
        this.localData = this.localData.map(x => {
          x.active = this.$scrollTrigger.isInViewport(`.${x.className}`, 0.1)
          return x
        })
      }
    }
  },
  data: () => ({
    scroll: null,
    isLoaded: false,
    localData: []
  }),
  computed: {
    scrollY () {
      return this.$store.state.scrollY
    }
  },
  methods: {
    getElementTop (className) {
      if (document) {
        // console.log(className, document.getElementsByClassName(className)[0].getBoundingClientRect().top)
        return document.getElementsByClassName(className)[0].getBoundingClientRect().top + window.innerHeight
      } else {
        return 0
      }
    },
    jump (item) {
      EventBus.$emit('scrollTo', document.getElementsByClassName(item.className)[0])
    }
  },
  created () {
    EventBus.$once('loaded', () => {
      this.isLoaded = true
    })
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
div.guide-line::v-deep {
  position: fixed;
  height: 75vh;
  z-index: 10000;
  display: flex;
  flex-wrap: wrap;
  align-content: center;

  &.left {
    width: 18px;
    top: 50%;
    transform: translateY(-50%);
    left: 3%;
    overflow: hidden;
    transition: all 1s ease;

    .slide {
      cursor: pointer;
      width: 100%;
      display: block;
      white-space: nowrap;
      height: 25px;
      margin: 2px 0;

      &:not(:first-child) {
        .pin {
          &:before {
            content: '';
            height: calc(100% - 10px);
            position: absolute;
            left: 8px;
            bottom: 100%;
            background: rgba(255, 255, 255, 0.8);
            width: 1px;
          }
        }

        &.active {
          .pin {
            &:before {
              content: '';
              height: calc(100% - 11px);
              position: absolute;
              left: 8px;
              bottom: 100%;
              background: rgba(255, 255, 255, 0.8);
              width: 1px;
            }
          }
        }
      }

      .pin {
        display: inline-block;
        width: 18px;
        height: 25px;
        position: relative;
        text-align: center;

        &:after {
          transition: all .15s linear;
        }

        img {
          width: 12px;
          transition: width .15s linear;
        }
      }

      .title {
        display: inline-block;
        width: 0;
        margin-left: 10px;
        height: 25px;
        font-size: 13px;
        color: rgba(255, 255, 255, .7);
        line-height: 25px;
        white-space: nowrap;
      }


      &.active {
        .pin {
          img {
            width: 18px;
          }

          &:after {
            top: 4px;
            left: 4px;
            position: absolute;
            content: '';
            border-radius: 50%;
            width: 10px;
            height: 10px;
            background: #fff;
          }
        }

        .title {
          font-size: 18px;
          color: #fff;
          font-weight: 700;
        }
      }
    }

    &:hover, &.on {
      width: 225px;

      //.title {
      //  width: 178px;
      //}
    }
  }

  &.right {
    top: 50%;
    transform: translateY(-50%);
    right: 3%;

    .slide {
      width: 100%;

      .title {
        font-size: 13px;
        color: rgba(255, 255, 255, .7);
        transition: all .3s linear;
        line-height: 25px;
      }

      &.active {
        .title {
          font-size: 18px;
          color: #fff;
          font-weight: 700;
        }
      }
    }
  }

  &.bottom {
    left: 50%;
    transform: translateX(-50%);
    bottom: 3%;
  }

  &.top {
    left: 50%;
    transform: translateX(-50%);
    top: 3%;
  }
}
</style>
